
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#008751","d":"M0 0h6v3H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M2 0h2v3H2z"}})])
          )
        }
      }
    